<template>
  <div>
    <!--列表-->
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <div style="margin-top: 5px; float:left;font-weight: bold; font-size: 14px" v-if="isFullPlatform">各店铺清仓完成进度</div>
        <div style="margin-bottom: 10px; float: right">
          <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
          <el-button type="primary" size="mini" @click="handleAdd('')" v-if="isFullPlatform" v-permission="`ec-pc-new$productLifeCycle$commodityClearManage$warehouseCearanceManagement$ClearAdd`">新增</el-button>
          <el-button type="primary" size="mini" @click="batchOffShelf" :disabled="!multipleSelection.length" v-if="isFullPlatform">下架</el-button>
          <el-button type="danger" size="mini" @click="del" :disabled="!multipleSelection.length" v-show="isFullPlatform" v-permission="`ec-pc-new$productLifeCycle$commodityClearManage$warehouseCearanceManagement$CleasrDelete`">删除</el-button>
          <el-button type="primary" size="mini" @click="importExcel" v-show="isFullPlatform" v-permission="`ec-pc-new$productLifeCycle$commodityClearManage$warehouseCearanceManagement$ClearImport`">导入</el-button>
        </div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          highlight-current-row
          :data="tableData.list || []"
          :height="tableHeight"
          v-if="tableHeight && tableReload"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :row-key="(row) => row.dataId"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable" v-if="isFullPlatform" fixed="left"></el-table-column>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
            :align="item.children ? 'center' : 'left'"
          >
            <template slot-scope="scope">
              <template v-if="item.label === '图片'">
                  <el-button
                   v-if="scope.row.imgList && scope.row.imgList.length"
                   size="mini"
                   type="text"
                   @click="viewImg(scope.row)"
                   >查看</el-button
                  >
                </template>
              <template v-else-if="item.prop == 'allocationNum'">
                <el-button type="text" @click="storeClick(scope)">{{scope.row.allocationNum}}</el-button>
              </template>
              <template v-else-if="item.prop == 'allocationNumTotal'">
                <el-button type="text" @click="storeAllClick(scope.row)">{{scope.row.allocationNumTotal}}</el-button>
              </template>
              <template v-else>
                {{ scope.row[item.prop] | cellValFormat }}
              </template>
            </template>
            <!-- 二级表头 -->
            <el-table-column
              show-overflow-tooltip
              v-show="item.children"
              v-for="(data, index) in item.children"
              :label="data.titleName"
              :prop="data.propertyName"
              :width="data.displayWidth"
              :key="data.propertyName + index"
            >
              <template slot-scope="scope">
                <template v-if="data.titleName == '分配量'">
                  <el-button type="text" @click="storeClick(scope,item.label)">{{scope.row[data.propertyName]}}</el-button>
                </template>
                <template v-else>
                  {{scope.row[item.prop] || scope.row[data.propertyName]}}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  @click="handleAdd(scope.row)" v-show="isFullPlatform" v-permission="`ec-pc-new$productLifeCycle$commodityClearManage$warehouseCearanceManagement$ClearEdit`">编辑</el-button>
              <el-button type="text" size="mini"  @click="offShelf(scope.row)" v-show="isFullPlatform" :disabled="scope.row.shelfRemoveFlag == 'Y'" v-permission="`ec-pc-new$productLifeCycle$commodityClearManage$warehouseCearanceManagement$Clearxiajia`">下架</el-button>
              <el-button type="text" size="mini"  @click="adjustment(scope.row)" v-if="!isFullPlatform" :disabled="scope.row.flag">调整</el-button>
              <el-button type="text" size="mini"  @click="details(scope.row)">查看调整记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right; padding-bottom: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增编辑 -->
    <add-dialog
      v-if="isShowAdd" 
      :visible.sync="isShowAdd" 
      :modifyData="modifyData" 
      :storeList="adialogAuthOptions"
      @finish="onSearch"
    />
    <!-- 店铺清仓情况 -->
    <store-clearance-dialog
      v-if="isShowStoreClearance" 
      :visible.sync="isShowStoreClearance" 
      :modifyData="modifyData" 
    />
    <!-- 全网清仓情况 -->
    <store-all-clearance-dialog
      v-if="isShowStoreAllClearance" 
      :visible.sync="isShowStoreAllClearance" 
      :modifyData="modifyData" 
    />
    <!-- 调整记录 -->
    <adjustment-record-dialog
      v-if="isShowAdjustmentRecord" 
      :visible.sync="isShowAdjustmentRecord" 
      :modifyData="modifyData" 
      :storeCode="searchForm.storeCode"
    />
    <!-- 调整 -->
    <adjustment-dialog
      v-if="isShowAdjustment" 
      :visible.sync="isShowAdjustment" 
      :modifyData="modifyData" 
      :storeList="adialogAuthOptions"
    />

    <!-- 查看图片弹窗 -->
      <el-dialog
        title="图片查看"
        :visible.sync="imgFormVisible"
        :close-on-click-modal="false"
        width="50%"
        v-esc-close
        ><imgShow :imgList="imgList"></imgShow
      ></el-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import addDialog from './add-dialog.vue'
import storeClearanceDialog from './storeClearance-dialog.vue'
import storeAllClearanceDialog from './storeAllClearance-dialog.vue'
import adjustmentRecordDialog from './adjustmentRecord-dialog.vue'
import adjustmentDialog from './adjustment-dialog.vue'
import imgShow from "@/views/components/imgShow";
import moment from 'moment'
import pagePathMixin from '@/utils/page-path-mixin'
// import customProps from '../customProps.mixin'
export default {
  name: "newProductSales",
  mixins: [pagePathMixin],
  model: { 
    prop: 'searchForm',
    event: 'input'
  },
  components: {
    addDialog,
    storeClearanceDialog,
    storeAllClearanceDialog,
    adjustmentRecordDialog,
    adjustmentDialog,
    imgShow
  },
  props: ['searchForm', 'formHeight', 'storeList', 'isFullPlatform'],
  data() {
    return {
      loading: false,
      exportLoading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      rules: {},
      columnData: [],
      reportName: 'clearStockGoodsStoreReport',
      multipleSelection: [],
      adialogAuthOptions: [],
      activeTable: 1,
      queryCriteria: [],
      imgFormVisible: false,
      tableReload: true,
      isShowAdd: false,
      isShowStoreClearance: false,
      isShowStoreAllClearance: false,
      isShowAdjustmentRecord: false,
      isShowAdjustment: false,
      imgFormVisible: false,
      imgList: [],
      modifyData: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 275  + (this.formHeight != '30px' ? -47 : 0);
    },
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  watch: {
    formHeight(val,old) {
      this.tableReload = false;
      this.$nextTick(_ => {
        this.tableReload = true;
      });
    },
  },
  methods: {
    selectable(row) {
      return row.shelfRemoveFlag == 'N'
    },
    columns() {
      this.loading = true
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.columnData = res.data.sysColumns.map(v => {
          return {
            label: v.displayName,
            prop: v.columnName,
            width: v.displayWidth,
            sortable: v.sortable == '1' ? "custom" : false,
            span: false,
            fixed: v.freezeType,
          }
        })
        this.onSearch();
      });
    },
    onSearch() {
      let platCodeType = this.searchForm.goodsCode && this.searchForm.goodsCode.split(" ").length > 1000
      if(platCodeType) {
        this.$message.error('已超过1000条，请核对！')
        return
      }
      this.$refs.table.clearSelection()
      this.tableData.pageNum = 1
      this.queryCriteria = [
        {
          attributeName: 'storeCode', //店铺
          val: [this.searchForm.storeCode ? this.searchForm.storeCode : ''],
          op: 'in'
        },
        {
          attributeName: 'goodsCode', //商品编码
          val: [this.searchForm.goodsCode ? this.searchForm.goodsCode : ''],
          op: 'in'
        },
        {
          attributeName: 'goodsName', //商品名称
          val: this.searchForm.goodsName ? this.searchForm.goodsName : '',
          op: 'like'
        },
        {
          attributeName: 'clearDate', //清仓时间
          val: this.searchForm.date && this.searchForm.date.length ? this.searchForm.date : [],
          op: "range"
        },
        {
          attributeName: 'clearanceStatus', //状态
          val: [this.searchForm.clearanceStatus ? this.searchForm.clearanceStatus : ''],
          op: "in"
        },
      ]
      this.init()
    },
    async init(type) {
      this.fullPlatformInit()
    },

    handlerDatas(arr) {  
      let obj = {}
      arr.forEach((item, index) => {
        let { parentName } = item
        if (!obj[parentName]) {
          obj[parentName] = {
            parentName,
            children: [],
            titleName: parentName ? parentName : item.titleName,
            propertyName: parentName ? parentName : item.propertyName,
            displayWidth: item.displayWidth
          }
        }
        obj[parentName].children.push(item)
      })
      let data = Object.values(obj) // 最终输出
      return data
    },
    //拥有全平台权限
    fullPlatformInit() {
      this.loading = true
      let time = this.searchForm.date
      let data = {
        ...this.searchForm,
        startTime: time && time.length ? time[0] : '',
        endTime: time && time.length ? time[1] : '',
        goodsCodeList: this.searchForm.goodsCode ? this.searchForm.goodsCode.split(' ') : [],
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize
      }
      delete data.goodsCode
      this.searchFormData = data
      this.$q.clearanceManagement.completeInfoSearch({data: data}).then(res => {
        if(res.data && res.data.dynamicData) {
          this.tableData = res.data.dynamicData
          let columnData = []
          let list = this.handlerDatas(res.data.titleList) //处理后的数据
          let listTwo = list.filter(v=>v.parentName) //二级表头列表
          columnData = list[0].children //一级表头列表
          columnData.splice(9,0,...listTwo) //顺序调整
          let columnDataTwo = columnData.filter(v=>v.children)[0].children //获取动态列二级下拉列
          var propertyName1 = columnDataTwo.filter(v=>v.titleName == '实销量')[0].propertyName //获取动态列实销量的字段名
          var propertyName2 = columnDataTwo.filter(v=>v.titleName == '分配量')[0].propertyName
          this.tableData.list = res.data.dynamicData.records.map(v=> {
            return {
              ...v,
              flag: v[propertyName1] > v[propertyName2] ? true : false  //实销量大于分配量禁用
            }
          })
          this.columnData = columnData.map(v => {
            return {
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: false,
              span: false,
              fixed: v.fixed == 1 ? 'left' : false,
              children: v.children || null
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      let searchForm = {
        storeCode: this.storeList[0].storeCode,
        clearanceStatus: '',
        batchNameList: []
      };
      this.$emit('input',searchForm)
      this.$emit('stroeChange')
      this.tableData.pageNum = 1
      // this.$nextTick(_=>{
      //   this.onSearch()
      // })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = typeof(row.imgList) == 'string' ? row.imgList.split('|').map(v=>{ return { path: v } }) : row.imgList
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },

    handleAdd(row) {
      this.modifyData = row ? {...row} : null
      this.isShowAdd = true
    },

    storeClick(scope,stroeName) {
      let storeCode = scope.column.property.replace('AllocationNum','').toUpperCase()
      let dataId = scope.row.dataId
      this.modifyData = {
        storeCode: storeCode,
        stroeName: stroeName,
        dataId: dataId,
        goodsCode: scope.row.goodsCode,
        batchName: scope.row.batchName,
      }
      this.isShowStoreClearance = true
    },
    storeAllClick(row) {
      this.modifyData = row
      this.isShowStoreAllClearance = true
    },
    details(row) {
      this.modifyData = row
      this.isShowAdjustmentRecord = true
    },
    adjustment(row) {
      this.modifyData = {...row,storeCode: this.searchForm.storeCode}
      this.isShowAdjustment = true
    },

    async offShelf(row) {
      let params = {
        fragment: [row.dataId]
      };
      let status = await this.$confirm("是否确认下架该商品？",'提示', {type: 'warning'});
      if (status !== "confirm") return;
      this.$q.clearanceManagement.goodsShelfRemove(params).then(res => {
        if (res.success) {
          this.$message.success("下架成功");
        } else {
          this.$message.fail("下架失败");
        }
        this.onSearch();
      });
    },
    async batchOffShelf() {
      let data = {
        dataIdList: this.multipleSelection.map(v=> v.dataId)
      };
      let status = await this.$confirm("是否确认下架该商品？",'提示', {type: 'warning'});
      if (status !== "confirm") return;
      this.$q.clearanceManagement.shelfRemoveBatch({data:data}).then(res => {
        if (res.success) {
          this.$message.success("下架成功");
        } else {
          this.$message.fail("下架失败");
        }
        this.onSearch();
      });
    },
    async del() {
      let data = {
        dataIdList: this.multipleSelection.map(v=> v.dataId)
      };
      let status = await this.$confirm("是否确认删除该商品？",'提示', {type: 'warning'});
      if (status !== "confirm") return;
      this.$q.clearanceManagement.goodsDel({data:data}).then(res => {
        if (res.success) {
          this.$message.success("删除成功");
        } else {
          this.$message.fail("删除失败");
        }
        this.onSearch();
      });
    },
    importExcel() {
      this.openSubPage({
        path: '/clearanceManagementStoreImport',
        query: {

        }
      })
    },
     // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
       this.$q.clearanceManagement.completeInfoExport({data: this.searchFormData,options: { responseType: 'blob' }}).then((res) => {
        let fileName = '清仓管理店铺'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.blobDownload( res, `${fileName}.xlsx`);
        loading.close()
      });
    },
    getAdialogAuthOptions() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm))
      currencyForm.reportCode = 'clearStockConfigStoreUpdateList'
       axios.post(`/ec-pc-api/custom/reports/data/clearStockConfigStoreUpdateList`,currencyForm).then(res => {
        if(res.code == 200) {
          this.adialogAuthOptions = res.data.list && res.data.list.length ? res.data.list.filter(v=>v.storeCode != '0'): []
        } 
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.$emit('getBatchNameList','')
    this.columns()
    this.getAdialogAuthOptions()
  },  
};
</script>

<style lang="stylus" scoped>
>>> .el-form--inline .el-form-item:last-child {
  margin-right: 0;
}

.list-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}

.header-redio {
  margin: 10px;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.table-wrap {
  padding: 10px;
  border-radius: 6px;
}

>>> .el-link.el-link--primary {
  margin-right: 5px;
}

// >>> .el-table .el-table__fixed {
//     height:auto !important; 
//     bottom:11px; 
// }

// >>> .el-table__fixed-right {
//   height:auto !important; 
//   bottom:11px;
// }


// >>> .el-table__body-wrapper {
//   &::-webkit-scrollbar { // 滚动条高 解决行未对齐
//     height: 11px;
//   }
// }
// >>> .el-table__fixed-body-wrapper .el-table__body {
//   padding-bottom: 11px; // 滚动条高度

// }
</style>
